<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-0">
        <div class="gray-dashed items-center">
            <label>授權人 </label>
            <div class="content">
                <span>{{ data?.name ||'未指定' }}</span>
            </div>
        </div>
        <div class="gray-dashed items-center">
            <label>身分證字號</label>
            <div class="content">
                {{ data?.id }}
            </div>
        </div>
        <div class="gray-dashed items-center md:col-span-2">
            <label>授權扣款銀行</label>
            <div class="content">
                {{ `${data?.shortBankCode} ${data?.bankName}` }}
            </div>
        </div>
        <div class="gray-dashed items-baseline md:col-span-2">
            <label>授權銀行帳號</label>
            <div class="content">
                <slot name="input" />
            </div>
        </div>
        <div class="gray-dashed items-baseline md:col-span-2">
            <label>授權人行動電話</label>
            <div class="content">
                <p>{{ data?.mobile }}</p>
                <ul class="text-tip text-sm mt-1">
                    <li>此電話僅供本授權之用，倘欲變更保單電話請從首頁申請保單變更。</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { EUDC } from '@/utils/EUDC';

export default {
    props: {
        data: {
            type: Object,
            default: () => { }
        }
    },
    setup() {
        EUDC();
    }
};
</script>

<style scoped lang="scss">
.gray-dashed {
    @apply border-t border-dashed border-gray-200 pt-2.5 pb-2 flex  min-h-[3rem];
    label {
        @apply flex-shrink-0 mr-4 text-sm xs:text-base text-gray-400 w-1/4 md:w-1/3 md:w-[7rem] min-w-[6.5rem];
    }
    .content {
        @apply text-base xs:text-lg;
    }
}
</style>
